"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
function TablePagination(_a) {
    var totalCount = _a.totalCount, limit = _a.limit, page = _a.page, setPage = _a.setPage;
    var pageFirstIndex = (page - 1) * limit;
    var pageLastIndex = pageFirstIndex + limit;
    var pageFirstIndexPlusOne = pageFirstIndex + 1;
    return (react_1.default.createElement("div", { className: "ng-table-pager pager" },
        react_1.default.createElement("div", { className: "count" },
            react_1.default.createElement("b", null, pageFirstIndexPlusOne),
            "-",
            react_1.default.createElement("b", null, pageLastIndex < totalCount ? pageLastIndex : totalCount),
            "\u00A0of\u00A0",
            react_1.default.createElement("b", null, totalCount)),
        react_1.default.createElement("ul", { className: "pagination ng-table-pagination" },
            react_1.default.createElement("li", { className: (0, clsx_1.default)({
                    disabled: page === 1,
                }) },
                react_1.default.createElement("a", { onClick: function () { return setPage(page - 1); } },
                    react_1.default.createElement("i", { className: "implioicons-chevron-left eva-pagination-icons" }))),
            __spreadArray([], __read(Array(Math.ceil(totalCount / limit) || 1)), false).map(function (_, index) { return (react_1.default.createElement("li", { key: index, className: (0, clsx_1.default)({
                    active: index + 1 === page,
                }) },
                react_1.default.createElement("a", { onClick: function () { return setPage(index + 1); } }, index + 1))); }),
            react_1.default.createElement("li", { className: (0, clsx_1.default)({
                    disabled: page === Math.ceil(totalCount / limit),
                }) },
                react_1.default.createElement("a", { onClick: function () { return setPage(page + 1); } },
                    react_1.default.createElement("i", { className: "implioicons-chevron-right eva-pagination-icons" }))))));
}
exports.default = TablePagination;
